import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../Datas/productData";
import "../css/about.scss";

function About() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <main className="about">
      <section className="about__hero" aria-labelledby="about-title">
        <img
          className="about__hero-image"
          src="/img/about-tiporchid-studio.jpg"
          alt="A woman setting down a tote in a sunlit apartment"
          width="2400"
          height="1350"
        />
        <div className="about__hero-copy">
          <p className="about__eyebrow">Our story</p>
          <h1 id="about-title">Objects for a life lived with intention.</h1>
          <p>
            {siteConfig.brandName} brings considered form, useful details, and a
            little warmth to the things you reach for every day.
          </p>
        </div>
      </section>

      <section className="about__manifesto" aria-labelledby="manifesto-title">
        <p className="about__eyebrow">Made for the everyday</p>
        <h2 id="manifesto-title">
          We believe good design should feel natural: beautiful enough to keep,
          practical enough to use.
        </h2>
        <div className="about__manifesto-copy">
          <p>
            Our collections begin with familiar routines—the morning commute, a
            weekend away, a thoughtful gift—and ask how each one could feel more
            effortless. We refine every proportion, pocket, and finish until the
            result feels quietly right.
          </p>
          <p>{siteConfig.description}</p>
        </div>
      </section>

      <section className="about__chapter" aria-labelledby="approach-title">
        <div className="about__chapter-heading">
          <p className="about__eyebrow">Our approach</p>
          <h2 id="approach-title">Thoughtful from first sketch to final use.</h2>
        </div>

        <ol className="about__principles">
          <li>
            <span>01</span>
            <div>
              <h3>Purpose leads</h3>
              <p>
                We start with a real need, then remove what does not serve it.
                The result is simple, intuitive, and easy to live with.
              </p>
            </div>
          </li>
          <li>
            <span>02</span>
            <div>
              <h3>Details matter</h3>
              <p>
                Material, balance, tactility, and colour are considered together
                so every piece feels coherent from every angle.
              </p>
            </div>
          </li>
          <li>
            <span>03</span>
            <div>
              <h3>Better, over time</h3>
              <p>
                We favour useful versatility and enduring shapes, while
                continually learning how to make more considered choices.
              </p>
            </div>
          </li>
        </ol>
      </section>

      <section className="about__note" aria-labelledby="note-title">
        <div>
          <p className="about__eyebrow">A note from our studio</p>
          <h2 id="note-title">Keep the useful. Make room for delight.</h2>
        </div>
        <blockquote>
          “The pieces that stay with us are rarely the loudest. They are the ones
          that understand our days, become part of our rituals, and make ordinary
          moments feel a little more considered.”
        </blockquote>
      </section>

      <section className="about__closing" aria-labelledby="closing-title">
        <p className="about__eyebrow">Come along</p>
        <h2 id="closing-title">Find your next everyday favourite.</h2>
        <div className="about__actions">
          <Link className="about__button about__button--dark" to="/shop" onClick={toTop}>
            Shop the collection
          </Link>
          <Link className="about__button about__button--text" to="/contact" onClick={toTop}>
            Talk to our team <span aria-hidden="true">↗</span>
          </Link>
        </div>
      </section>
    </main>
  );
}

export default About;
